import styled from 'styled-components'

const Loader = () => {
    return (
        <CustomLoader>
            <div class="lds-dual-ring"></div>
        </CustomLoader>
    )
}

export default Loader

const CustomLoader = styled.div`
    .lds-dual-ring {
        display: inline-block;
        width: 60px;
        height: 60px;
    }
    .lds-dual-ring:after {
        content: ' ';
        display: block;
        width: 50px;
        height: 50px;
        margin: 8px;
        border-radius: 50%;
        border: 5px solid #8C66FF;
        border-color: #8C66FF transparent #8C66FF transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }
    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`
